import axios from 'axios';
import moment from 'moment';

interface PriceModelInput {
  productId: number;
  // počet ývazků
  debtsCount?: number;
  // výše dluhů
  debtsSum?: number;
  // způsob úhrady
  paymentType: string;
  // výše poplatku
  price?: number;
  // rozdělení platby na 2
  dividePayment: boolean;
  dateFirstPayment: string;
  dateSecondPayment?: string;
  // typ splátek
  installmentsType?: string;
  // výše první splátky
  firstPayment?: number;
  // počet splátek
  paymentsCount?: number;
}

export interface PriceModel {
  // výše platby (plateb)
  firstPrice: number;
  secondPrice?: number;
  // min. a max. výše ceny
  minimumPrice: number;
  maximumPrice: number;
  // blokace možnosti ceny editovat
  disablePrices: boolean;
  // dovoluje rozdělit platbu na 2
  canDividePrice: boolean;
  // možnost na splátky
  installments: {
    // možné typy splátek
    canFixed: boolean;
    canEqually: boolean;
    // minimální 1. splátka u fixu
    minimalFirstPayment?: number;
    // chyba
    error?: string;
    // cena produktu podle nastavení
    price?: number;
    // plán splátek
    paymentsPlan?: any[];
  };
}

export const getPriceModel = async ({ dateFirstPayment, ...params }: PriceModelInput): Promise<PriceModel> =>
  axios
    .post(`${process.env.REACT_APP_API_URL}/price-model`, {
      ...params,
      contractDate: moment().format('Y-MM-DD'),
      dateFirstPayment: dateFirstPayment || moment().format('Y-MM-DD'),
    })
    .then((response) => response.data);
